import Vue from 'vue'
import Vuex from 'vuex'
///////////////////////////
// imported state modules
import sidebar from '@/store/modules/sidebar'
import filterBy from '@/store/modules/filterBy'
import productTrust from '@/store/modules/productTrust'
import dataTypes from '@/store/modules/dataTypes'
import trustCenter from '@/store/modules/trustCenter'
import updates from '@/store/modules/updates'
import columnMatching from '@/store/modules/columnMatching'
import documents from '@/store/modules/documents'
import user from '@/store/modules/user'
import loader from '@/store/modules/loader'
import faq from '@/store/modules/faq'
import scroll from '@/store/modules/scroll'
import domains from '@/store/modules/domains'
import mainNavbar from '@/store/modules/mainNavbar'
import searchDropdown from '@/store/modules/searchDropdown'
import searchResultsDocuments from '@/store/modules/searchResultsDocuments'
import searchResultsUpdates from '@/store/modules/searchResultsUpdates'
import searchResultsKnowledgeBaseCard from '@/store/modules/searchResultsKnowledgeBaseCard'
import aiAnswers from '@/store/modules/aiAnswers'
import nda from '@/store/modules/nda'
import uploadQuestions from '@/store/modules/uploadQuestions'
import hamMenu from '@/store/modules/hamMenu'
import drawer from '@/store/modules/drawer'
import window from '@/store/modules/window'

Vue.use(Vuex)
//////////////////////////
const createStore = () => {
  // domain: 'trust-dev.vendict.com',
  return new Vuex.Store({
    state: {
      teamId: '',
      token: '',
      domain: 'trust-dev.vendict.com',
      products: [],
    },
    mutations: {
      SET_TEAMID(state, teamId) {
        console.log('Inside SET_TEAMID - teamId', teamId)
        state.teamId = teamId
      },
      SET_TOKEN(state, token) {
        console.log('Inside SET_TOKEN - token', token)
        console.trace()
        state.token = token
      },
      SET_DOMAIN(state, domain) {
        console.log('Inside SET_DOMAIN - domain', domain)
        state.domain = domain
      },
      SET_PRODUCTS_LIST_TRUST(state, products) {
        console.log('Inside SET_PRODUCTS_LIST_TRUST - products', products)
        state.products = products
      },
    },
    actions: {},
    getters: {
      GET_TOKEN: (state) => {
        return state.token
      },
      GET_TEAMID: (state) => {
        return state.teamId
      },
      GET_DOMAIN: (state) => {
        return state.domain
      },
      GET_PRODUCTS_LIST_TRUST(state) {
        let res = state.products
        // sort alphabetic
        res.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
        return res
      },
    },
    modules: {
      sidebar,
      filterBy,
      dataTypes,
      productTrust,
      updates,
      columnMatching,
      documents,
      faq,
      loader,
      user,
      aiAnswers,
      nda,
      domains,
      scroll,
      mainNavbar,
      searchDropdown,
      searchResultsDocuments,
      searchResultsUpdates,
      searchResultsKnowledgeBaseCard,
      uploadQuestions,
      hamMenu,
      drawer,
      trustCenter,
      window,
    },
  })
}

export default createStore
